import {Injectable} from '@angular/core';
import {AbstractDataServiceDtoSummaryAdapter} from "../../../../../../core/service/v2/dataservice/adapter/abstractDataServiceDtoSummaryAdapter";
import {FormDefinitionFormSummaryModel} from "../../../api/entity/formDefinitionFormSummary.model";
import {FormDefinitionFormSummaryConverter} from "../../../api/entity/converter/formDefinitionFormSummary.converter";
import {FormDefinitionFormModel} from "../../../api/entity/formDefinitionForm.model";
import {FormDefinitionFormDataService} from "./formDefinitionFormData.service";

@Injectable()
export class FormDefinitionFormSummaryDataServiceAdapter extends AbstractDataServiceDtoSummaryAdapter<FormDefinitionFormSummaryModel, FormDefinitionFormSummaryConverter, FormDefinitionFormModel> {
    constructor(dataService: FormDefinitionFormDataService, converter: FormDefinitionFormSummaryConverter) {
        super(dataService, converter);
    }

    newStoredEntityInstance(): FormDefinitionFormModel {
        return new FormDefinitionFormModel();
    }


}
